import Avatar, { getInitials } from '../primitives/Avatar'
import styles from './ProfileScreen.module.css'

interface ProfileHeroProps {
  firstName: string
  lastName: string
  photoUrl?: string
  isUploading?: boolean
  children: React.ReactNode
}

export default function ProfileHero({
  firstName,
  lastName,
  photoUrl,
  isUploading,
  children,
}: ProfileHeroProps) {
  return (
    <section className={styles.hero}>
      <Avatar
        initials={getInitials(firstName, lastName)}
        photoUrl={photoUrl}
        size="xl"
        isLoading={isUploading}
      />
      <div className={styles.identity}>{children}</div>
    </section>
  )
}
